function loadOrganizationModule(component) {
  return () => import(`@/components/organization/${component}.vue`)
}

export default [
  {
    name: 'organization',
    path: '/organization',
    component: () => import(/* webpackChunkName: "organization-view-page" */ '../view/OrganizationView.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: 'organization.history',
        path: 'history',
        component: loadOrganizationModule('Index'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'organization.view',
        path: 'view/:organiId',
        props: true,
        component: loadOrganizationModule('View'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'organization.create',
        path: 'create',
        props: true,
        component: loadOrganizationModule('Create'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'organization.update',
        path: 'update',
        props: true,
        component: loadOrganizationModule('Update'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
]
